import React, { DetailedHTMLProps } from 'react'

import style from './Loader.module.css'

import { ReactComponent as LoaderSVG } from 'assets/loaders/loader.svg'

export const Loader = ({ className, ...props }: DetailedHTMLProps<any, HTMLDivElement>) => {
  return <LoaderSVG className={`${style.loader} ${className}`} {...props} />
}
